import PhoneInput from '_core/components/PhoneInputNew';

export default PhoneInput;
